import { env } from '@app/env'

import { resolveAuthToken } from './resolveAuthToken'

export type DocumentLinkOptions = { download?: boolean }

export const isDownloadUserDocumentsLink = (url: string) =>
  url.startsWith(env.REACT_APP_DOWNLOAD_USER_DOCUMENTS_PUBLIC_URL)

const withAuthToken = (
  url: string,
  token: string | undefined,
  { download }: DocumentLinkOptions
): string => {
  if (!isDownloadUserDocumentsLink(url)) {
    return url
  }

  const authorizedUrl = new URL(url)

  if (token) {
    authorizedUrl.searchParams.set('token', token)
  }

  if (download !== undefined) {
    authorizedUrl.searchParams.set('download', String(download))
  }

  return authorizedUrl.href
}

export const withFreshAuthTokens = async (
  urls: string[],
  options: DocumentLinkOptions = {}
): Promise<string[]> => {
  const token = urls.some(isDownloadUserDocumentsLink) ? await resolveAuthToken() : undefined

  return urls.map((url) => withAuthToken(url, token, options))
}

export const openDocuments = async (
  urls: string[],
  options?: DocumentLinkOptions
): Promise<void> => {
  const authorizedUrls = await withFreshAuthTokens(urls, options)

  authorizedUrls.forEach((url) => window.open(url, '_blank'))
}
